export default function WithdrawToast() {
  return (
    <span>
      Successfully requested withdrawal: see{' '}
      <button
        className="underline"
        onClick={() => {
          const navigate = new CustomEvent('app:navigate', {
            detail: { pathname: '/portfolio', search: '?view=transfers' },
          });
          window.dispatchEvent(navigate);
        }}
      >
        Transfers
      </button>
    </span>
  );
}
